export default function () {
  return {
    brands: [],
    brand: {},
    lists: [],
    groupPrincipals: [],
    groupForm: {}
  }
}
